import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from './use-protected-query';
import useProtectedMutation from './use-protected-mutation';

import RebatesClient from '../RebatesClient';
import { queryOptions } from '@tanstack/react-query';
// import { useParams } from 'react-router-dom';

export default function useAccountByName(props) {
    const { state: userData } = useContext(LoginContext);


    const { accountName, accountType } = props
    const {
        data: account,
        isLoading: accountLoading,
        error: accountError,
        refetch: refetchaccount
    } = useProtectedQuery({
        queryKey: ['get_strategic_account',],
        queryFn: async () => {
            let url = `/api/accounts/get-account?accountName=${encodeURIComponent(accountName)}&accountType=${accountType}`;


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting account");
            }

        },
    });



    return {
        account,
        accountLoading,
        accountError,
        refetchaccount,



    }
}
